<div class="urgency-boost-display-conditions">
  <pdq-card variant="popover" color="white">
    <div class="card-content">
      <pdq-heading element="h6">Display Conditions</pdq-heading>
      <span class="section-label">This Extension Will Only Appear If:</span>
      <pdq-rules-dynamic-form
        [formGroup]="formGroup"
        formArrayFieldName="restrictionsRules"
        [rules]="displayRules"
        [entities]="displayRulesEntities"
        [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
    </div>
  </pdq-card>
</div>
